import { Flex, Input, Select, Option } from '@pega/cosmos-react-core';
import type { PopoverProps } from '@pega/cosmos-react-core';

import Popover from './Popover';

interface ItemConfigProps {
  target: NonNullable<PopoverProps['target']>;
  onCancel: () => void;
  onSubmit: () => void;
}

const comparisionTypes = [
  'Integer',
  'Decimal',
  'Currency',
  'Date & time',
  'Date only',
  'Time only'
];

const GroupConfig = ({ target, onCancel, onSubmit }: ItemConfigProps) => {
  return (
    <Popover target={target} heading='Create Group' onCancel={onCancel} onSubmit={onSubmit}>
      <Flex container={{ direction: 'column', gap: 2 }}>
        <Input label='Heading' required />
        <Select label='Allowed types'>
          <Option value='All'>All</Option>
          {comparisionTypes.map(type => {
            return <Option value={type}>{type}</Option>;
          })}
        </Select>
        <div>Etc...</div>
      </Flex>
    </Popover>
  );
};

export default GroupConfig;
